// extracted by mini-css-extract-plugin
export default {"title":"ymZzzuhuDJ8xd3GOLsXg","text":"zPFGqHnKBoCp3gzmZjWv"};